<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="610px"
    :title="$l('dialog_title_batch_update_material') || '批量更新材料信息'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_materialInfo') || '材料信息'"
            prop="materialInfo"
          >
            <el-input
              v-model="formData.materialInfo"
              :placeholder="materialInfoData.p_materialInfo"
              type="textarea"
              clearable
              show-word-limit
              :rows="4"
              :maxlength="1000"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_materialInfoEn') || '英文材料信息'"
            prop="materialInfoEn"
          >
            <el-input
              v-model="formData.materialInfoEn"
              :placeholder="materialInfoData.p_materialInfoEn"
              type="textarea"
              clearable
              show-word-limit
              :rows="4"
              :maxlength="1000"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">{{
        $l('INDEX.btn_cancel') || '取 消'
      }}</el-button>
      <el-button size="medium" type="primary" @click="save">{{
        $l('INDEX.btn_update') || '更新'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: true },
    detailCategoryCode: { type: String, default: '' },
  },
  data() {
    return {
      materialInfoData: {
        p_materialInfo: '',
        p_materialInfoEn: '',
      },
      formData: {},
      ctnGrossWeightKgRead: 0,
      ctnNetWeightKgRead: 0,
    }
  },
  async mounted() {
    await this.goodsStandard()
  },
  computed: {
    rules() {
      return {
        materialInfoEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        materialInfo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async goodsStandard() {
      if (!this.detailCategoryCode) return
      const res = await this.$api.masterGoodsInputStandardCategoryDetailApi({
        categoryCode: this.detailCategoryCode,
      })
      if (!res) return
      this.materialInfoData.p_materialInfo = res.body?.materialInfo
      this.materialInfoData.p_materialInfoEn = res.body?.materialInfoEn
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const params = {
        ...this.formData,
      }
      this.$emit('saveMaterialInfo', params)
    },
  },
}
</script>
